import $ from 'jquery';

/* global x5script */

class TeamMembers {
  constructor() {
    this.isTeamPage = $('.js-team-page');

    if (!this.isTeamPage.length) {
      return;
    }

    this.departmentLink = $('.js-team-department-link');
    this.memberInfoLink = $('.js-team-member-info-link');
    this.memberInfo = $('.js-team-member-info');
    this.member = $('.js-team-member');

    $(window).on('load', () => {
      this.toggleDepartments();
      this.toggleMemberInfo();
      this.toggleMemberViaHashLink();
    });

    $(window).on('popstate', () => {
      this.toggleDepartmentsViaHistory();
    });
  }

  toggleMemberViaHashLink() {
    this.memberId = window.location.hash;

    if (this.memberId === '') {
      return;
    }

    let member = $(`.js-team-member${this.memberId}`);

    if (!member.length) {
      member = $(`.js-team-department-link[href="${this.memberId}"`);
    }

    if (member.length) {
      const department = member.closest('.js-team-department');

      department.addClass('is-active');

      if (member.hasClass('has-info')) {
        member
          .addClass('is-active')
          .find('.js-team-member-info')
          .show();
        member.find('.js-team-member-info-link').text(x5script.lessInfoText);
      }

      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: member.offset().top - 100,
          },
          500,
        );
    }
  }

  toggleDepartments() {
    this.departmentLink.on('click', e => {
      e.preventDefault();
      const self = $(e.currentTarget);
      const href = self.attr('href');
      const department = self.closest('.js-team-department');
      const members = department.find('.js-team-members');

      if (department.hasClass('is-active')) {
        members.slideUp(400, () => {
          department.removeClass('is-active');
          this.member.removeClass('is-active');
          this.memberInfo.hide();
        });
      } else {
        members.slideDown(400, () => {
          department.addClass('is-active');

          TeamMembers.scrollToDepartment(department);

          if (
            window.history.state === null ||
            window.history.state.team !== href
          ) {
            window.history.pushState({ team: href }, href.slice(1), href);
          }
        });
      }
    });
  }

  toggleDepartmentsViaHistory() {
    this.membersId = window.location.hash;

    if (this.membersId.trim() !== '' && $(this.membersId).length) {
      const department = $(this.membersId).parent();

      TeamMembers.scrollToDepartment(department, true);
    }
  }

  toggleMemberInfo() {
    this.memberInfoLink.on('click', e => {
      e.preventDefault();
    });

    this.member.on('click', e => {
      const self = $(e.currentTarget);
      const infoLink = self.find('.js-team-member-info-link');
      const info = self.find('.js-team-member-info');

      if (info.length) {
        if (self.hasClass('is-active')) {
          info.slideUp(300, () => {
            self.removeClass('is-active');
            infoLink.text(x5script.moreInfoText);
          });
        } else {
          info.slideDown(300, () => {
            self.addClass('is-active');
            infoLink.text(x5script.lessInfoText);
          });
        }
      }
    });
  }

  static scrollToDepartment(department, click = false) {
    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: department.offset().top - 50,
        },
        500,
        () => {
          if (click && !department.hasClass('is-active')) {
            department.find('.js-team-department-link').trigger('click');
          }
        },
      );
  }
}

export default new TeamMembers();



// WEBPACK FOOTER //
// ./src/scripts/modules/team-members.js